import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ProductDataSectionComponent } from '../../../app/content/modules/page/components/product/components/product-data-section/product-data-section.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../../_mocks/wine-product.mock';

const meta: Meta<ProductDataSectionComponent> = {
  title: 'Organisms/Product/Product Data Section',
  component: ProductDataSectionComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<ProductDataSectionComponent>;

export const FullWineData: Story = {
  args: {
    product: createDamilanoBarberaProduct(),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.product-data-section')).toBeTruthy();
  },
};

export const MinimalData: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      meta: {
        __typename: 'WineMeta',
        alcohol: '13.5%',
        countryName: 'Frankrig',
        countryEnt: { __typename: 'Country', id: 'country-fr', title: 'Frankrig', urlPath: '/lande/frankrig' },
        vintage: 2020,
        productType: 'Vin',
        contents: '75 cl',
        contentsCl: 75,
        contentLabel: '75 cl',
      } as any,
    }),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.product-data-section')).toBeTruthy();
  },
};

export const NonWineProduct: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      title: 'Premium Olivolja',
      meta: {
        __typename: 'WineMeta',
        productType: 'Tilbehør',
        countryName: 'Italien',
        countryEnt: { __typename: 'Country', id: 'country-it', title: 'Italien', urlPath: '/lande/italien' },
        contentLabel: '500 ml',
        contents: '500 ml',
        contentsCl: 50,
      } as any,
    }),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.product-data-section')).toBeTruthy();
  },
};
